import { TSearchPageParams } from "@features/offer/mobile/search/SearchPage";
import SearchViewStore from "@state/stores/offer/search/SearchViewStore.mobile";

const VALID_URL_KEYS: Array<keyof TSearchPageParams> = [
	"page",
	"action",
	"tournamentId",
	"sportId",
	"categoryId",
	"displayText",
	"eventId",
];
export function parseSearchPageParameters(params: TSearchPageParams) {
	const parsedParameters = {} as NonNullable<SearchViewStore["params"]>;
	for (const [key, value] of Object.entries(params) as Array<
		[keyof TSearchPageParams, string]
	>) {
		if (VALID_URL_KEYS.includes(key)) {
			try {
				const parsed = JSON.parse(value);
				/* @ts-expect-error */
				parsedParameters[key] = parsed as TSearchPageParams[typeof key];
			} catch (e) {
				console.error(`Failed to parse ${String(key)}:`, e);
				/* @ts-expect-error */
				parsedParameters[key] = value as TSearchPageParams[typeof key];
			}
		}
	}

	return parsedParameters;
}
